/**
 * Mount de `/cvn-top10.html` — Top 10 apontajes (Fase 5g.3).
 *
 * Flujo:
 *  1. `mountChrome` con el skin del proyector (`chrome-wood--cvn-top10`).
 *     Página pública de solo lectura.
 *  2. Inyecta el shell del ranking sobre la pantalla del proyector.
 *  3. Carga en paralelo `GET /api/greenie-board` (medias) y
 *     `GET /api/pilots` (foto del nº 1), calcula el Top 10 y lo pinta.
 *
 * Se llega desde el hotspot del proyector de la ready room.
 */

import { mountChrome } from '../chrome/index.js';
import { fetchGreenieBoard } from '../greenie-board/api.js';
import { fetchPilots } from '../logbook/api.js';
import {
  computeTop10,
  renderTop10,
  renderTop10Note,
  renderTop10Shell,
} from './markup.js';

import './cvn-top10.css';

export async function mountCvnTop10(): Promise<void> {
  const { contentRoot } = await mountChrome({
    activeSection: 'cvn-top10',
    allowAnonymous: true,
  });

  contentRoot.innerHTML = renderTop10Shell();
  const bodyZone = contentRoot.querySelector<HTMLElement>('[data-zone="body"]');
  if (!bodyZone) {
    throw new Error('[cvn-top10] shell incompleto tras el render');
  }
  bodyZone.innerHTML = renderTop10Note('Cargando ranking…');

  const [gb, pilots] = await Promise.all([fetchGreenieBoard(), fetchPilots()]);
  if (!gb.ok) {
    bodyZone.innerHTML = renderTop10Note(gb.message, true);
    return;
  }

  // Las fotos de perfil son opcionales: si `/api/pilots` falla, el
  // ranking se pinta igual, solo que el nº 1 sale con un placeholder.
  const avatars = new Map<string, string>();
  if (pilots.ok) {
    for (const p of pilots.data) {
      if (p.avatarUrl) avatars.set(p.callsign.toLowerCase(), p.avatarUrl);
    }
  }

  const ranking = computeTop10(gb.data.pilots);
  if (ranking.length === 0) {
    bodyZone.innerHTML = renderTop10Note(
      '— Todavía no hay apontajes registrados. —',
    );
    return;
  }
  bodyZone.innerHTML = renderTop10(ranking, avatars);
}
